import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  Container,
  Step,
  StepLabel,
  Stepper,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress
} from "@mui/material";
import FunctionsData from "../Functions/FunctionsData";
import logo from '../img/spca-sc.png';
import { Step4Final } from "./Landing/Step4Final";
import Step3 from "./Landing/Step3";
import Step2 from "./Landing/Step2";
import Step1 from "./Landing/Step1";
import Step0 from "./Landing/Step0";
import StartPage from "./Landing/StartPage";

const codeUnlock = "shelterbuddy";
const jwtKey = process.env.REACT_APP_JWT_KEY;
const defaultLogo = 'https://www.dropbox.com/s/tjdta5zikpage2h/default.png?dl=1';

const StepperComponent = (props) => {
  const [vetName, setVetName] = useState('Select Vet');
  const [currentVet, setCurrentVet] = useState(0);
  const [currentVetArr, setCurrentVetArr] = useState([]);
  const [aStep, setAStep] = useState(0);
  const [postCode, setPostcode] = useState('');
  const [googlePlace, setGooglePlace] = useState([]);
  const [frmFn, setFrmFn] = useState('');
  const [frmLn, setFrmLn] = useState('');
  const [frmStreet, setFrmStreet] = useState('');
  const [frmStreetNumber, setFrmStreetNumber] = useState('');
  const [frmCity, setFrmCity] = useState('');
  const [frmDPID, setFrmDPID] = useState(0);
  const [frmEmail, setFrmEmail] = useState('');
  const [frmPhone, setFrmPhone] = useState('');
  const [formattedAddress, setFormattedAddress] = useState('');
  const [suburb, setSuburb] = useState('');
  const [animals, setAnimals] = useState([]);
  const [frmCampaign, setFrmCampaign] = useState(0);
  const [frmMarketingOptin, setFrmMarketingOptin] = useState('');
  const [frmOrderID, setFrmOrderID] = useState(0);
  const [postcodes, setPostcodes] = useState([]);
  const [loadingPostcodes, setLoadingPostcodes] = useState(true);
  const [vets, setVets] = useState([]);
  const [sponsorId, setSponsorId] = useState(0);
  const [sponsorName, setSponsorName] = useState('');
  const [sponsorProgram, setSponsorProgram] = useState('');
  const [sponsorCost, setSponsorCost] = useState(0.00);
  const [sponsorMicrochipExtraCost, setSponsorMicrochipExtraCost] = useState(0.00);
  const [sponsorEmailText, setSponsorEmailText] = useState('');
  const [sponsorLogo, setSponsorLogo] = useState(defaultLogo);
  const [isSpcaEntered, setIsSpcaEntered] = useState(false);

  const steps = [
    vetName,
    'Add your details',
    'Enter your animals',
    'Get voucher'
  ];

  useEffect(() => {
    FunctionsData.fetchDataGet(
      '/api/campaign/postcodes',
      setPostcodes,
      loadingPostcodes,
      setLoadingPostcodes
    )
  }, []);

  useEffect(() => {
    FunctionsData.fetchDataGetNoLoading(
      '/api/campaign/vets',
      setVets
    )
  }, [])

  useEffect(() => {
    let ac = googlePlace;
    setFormattedAddress(ac['address']);
    setPostcode(String(ac['POSTCODE']));
    setFrmCity(ac['TOWN_CITY_MAILTOWN']);
    setSuburb(ac['SUBURB_NAME']);
    setFrmStreet(ac['STREET_NAME']);
    setFrmDPID(ac['DPID']);
    setFrmStreetNumber(ac['STREET_NUMBER']);
  }, [googlePlace])

  useEffect(() => {
    if (currentVet !== 0) {
      let v = vets.find(({ id }) => id === currentVet);
      setVetName('Vet: ' + v.business_name);
      setCurrentVetArr(v);
    }
  }, [currentVet, vets])

  useEffect(() => {
    if (aStep === 0) {
      window.gtag('set', 'page_path', '/select_vet');
      window.gtag('event', 'page_view', { page_title: '#1 - Address search and vet selection' });
    }

    if (aStep === 1) {
      window.gtag('set', 'page_path', '/client_info');
      window.gtag('event', 'page_view', { page_title: '#2 - Add client information' });
    }

    if (aStep === 2) {
      window.gtag('set', 'page_path', '/add_animals');
      window.gtag('event', 'page_view', { page_title: '#3 - Add animals to order' });
    }

    if (aStep === 3) {
      window.gtag('set', 'page_path', '/finalise_order');
      window.gtag('event', 'page_view', { page_title: '#4 - Finalise order' });
    }

    if (aStep === 4) {
      window.gtag('set', 'page_path', '/order_sent');
      window.gtag('event', 'page_view', { page_title: '#5 - Order sent' });
    }
  }, [aStep])

  if (aStep === 0) {
    return (
      <div className={"form-container"}>
        <Steps aStep={aStep} steps={steps} />
        <Step0 postCode={postCode}
          setPostCode={setPostcode}
          aStep={aStep}
          setAStep={setAStep}
          setStep={props.setStep}
          setCurrentVet={setCurrentVet}
          googlePlace={googlePlace}
          setGooglePlace={setGooglePlace}
          postcodes={postcodes}
          ReactGA={props.ReactGA}
          setSponsorId={setSponsorId} sponsorId={sponsorId}
          setSponsorName={setSponsorName} sponsorName={sponsorName}
          setSponsorProgram={setSponsorProgram} sponsorProgram={sponsorProgram}
          setSponsorCost={setSponsorCost} sponsorCost={sponsorCost}
          setSponsorMicrochipExtraCost={setSponsorMicrochipExtraCost} sponsorMicrochipExtraCost={sponsorMicrochipExtraCost}
          setSponsorEmailText={setSponsorEmailText} sponsorEmailText={sponsorEmailText}
          setSponsorLogo={setSponsorLogo} sponsorLogo={sponsorLogo}
          defaultLogo={defaultLogo}
          resetSelection={props.resetSelection}
          microchipOnly={props.microchipOnly}
          setMicrochipOnly={props.setMicrochipOnly}
        />
      </div>
    )
  }

  if (aStep === 1) {
    return (
      <div className={"form-container"}>
        <Steps aStep={aStep} steps={steps} />
        <Step1 postCode={postCode} setPostCode={setPostcode}
          aStep={aStep} setAStep={setAStep}
          frmFn={frmFn} setFrmFn={setFrmFn}
          frmLn={frmLn} setFrmLn={setFrmLn}
          frmStreet={frmStreet} setFrmStreet={setFrmStreet}
          frmStreetNumber={frmStreetNumber} setFrmStreetNumber={setFrmStreetNumber}
          frmCity={frmCity} setFrmCity={setFrmCity}
          frmEmail={frmEmail} setFrmEmail={setFrmEmail}
          frmPhone={frmPhone} setFrmPhone={setFrmPhone}
          frmMarketingOptin={frmMarketingOptin}
          setFrmMarketingOptin={setFrmMarketingOptin}
          ReactGA={props.ReactGA}
          codeUnlock={codeUnlock}
          microchipOnly={props.microchipOnly} setMicrochipOnly={props.setMicrochipOnly}
        />
      </div>
    )
  }

  if (aStep === 2) {
    return (
      <div className={"form-container"}>
        <Steps aStep={aStep} steps={steps} />
        <Step2 aStep={aStep} setAStep={setAStep}
          animals={animals} setAnimals={setAnimals}
          frmCampaign={frmCampaign} setFrmCampaign={setFrmCampaign}
          isSpcaEntered={isSpcaEntered} setIsSpcaEntered={setIsSpcaEntered}
          frmEmail={frmEmail}
          postCode={postCode}
          ReactGA={props.ReactGA}
          codeUnlock={codeUnlock}
          microchipOnly={props.microchipOnly} setMicrochipOnly={props.setMicrochipOnly}
        />
      </div>
    )
  }

  if (aStep === 3) {
    return (
      <div className={"form-container"}>
        <Steps aStep={aStep} steps={steps} />
        <Step3 postcode={postCode}
          aStep={aStep} setAStep={setAStep}
          frmOrderID={frmOrderID} setFrmOrderID={setFrmOrderID}
          frmFn={frmFn}
          frmLn={frmLn}
          frmStreet={frmStreet}
          frmStreetNumber={frmStreetNumber}
          frmCity={frmCity}
          frmEmail={frmEmail}
          frmPhone={frmPhone}
          frmCampaign={frmCampaign}
          frmDPID={frmDPID}
          suburb={suburb}
          formattedAddress={formattedAddress}
          animals={animals}
          currentVetArr={currentVetArr}
          ReactGA={props.ReactGA}
          frmMarketingOptin={frmMarketingOptin}
          sponsorId={sponsorId}
          sponsorName={sponsorName}
          sponsorProgram={sponsorProgram}
          sponsorCost={sponsorCost}
          sponsorMicrochipExtraCost={sponsorMicrochipExtraCost}
          sponsorEmailText={sponsorEmailText}
          sponsorLogo={sponsorLogo}
          jwtKey={jwtKey}
          microchipOnly={props.microchipOnly}
        />
      </div>
    )
  }

  if (aStep === 4) {
    return (
      <div className={"form-container"}>
        <Step4Final
          animals={animals} setAnimals={setAnimals}
          frmOrderID={frmOrderID}
          currentVetArr={currentVetArr}
          aStep={aStep} setAStep={setAStep}
          jwtKey={jwtKey}
          frmFn={frmFn}
          frmLn={frmLn}
          frmEmail={frmEmail}
          ReactGA={props.ReactGA}
          microchipOnly={props.microchipOnly} setMicrochipOnly={props.setMicrochipOnly}
        />
      </div>
    )
  }

  return null;
}

export default function Landing(props) {
const [selectedOption, setSelectedOption] = useState(null);
  const [step, setStep] = useState(0);

  // State for lost voucher modal
  const [lostVoucherOpen, setLostVoucherOpen] = useState(false);
  const [lostEmail, setLostEmail] = useState('');
  const [voucherCount, setVoucherCount] = useState(null);
  const [fetchingVouchers, setFetchingVouchers] = useState(false);
  const [voucherOrderIds, setVoucherOrderIds] = useState([]);
  const [resendMessage, setResendMessage] = useState('');
  const [resending, setResending] = useState(false);

  const handleOpenLostVoucher = () => {
    setLostVoucherOpen(true);
    setVoucherCount(null);
    setLostEmail('');
    setVoucherOrderIds([]);
    setResendMessage('');
    setResending(false);
  }

  const handleCloseLostVoucher = () => {
    setLostVoucherOpen(false);
    setVoucherCount(null);
    setFetchingVouchers(false);
    setVoucherOrderIds([]);
    setResendMessage('');
    setResending(false);
  }

  const handleSearchVouchers = async () => {
    if (!lostEmail) return;
    setFetchingVouchers(true);
    try {
      const tkn = await FunctionsData.getCSRFToken();
      const res = await fetch(
        FunctionsData.getApiUrl('/api/voucher/byemail?email=' + encodeURIComponent(lostEmail)), 
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'token': FunctionsData.getSessionToken(),
            'X-CSRF-Token': tkn.csrf
          }
        }
      );
      const data = await res.json();
      if (data.found) {
        setVoucherCount(data.count);
        setVoucherOrderIds(data.order_ids || []);
      } else {
        setVoucherCount(0);
      }
    } catch (err) {
      console.error(err);
      setVoucherCount(0);
    }
    setFetchingVouchers(false);
  }

  const handleResendVouchers = async (orderIds, frmEmail, frmFn) => {
    setResending(true);
    try {
      const csrf = await FunctionsData.getCSRFToken();
      const tkn = FunctionsData.getSessionToken();

      let failures = 0;

      const uniqueOrderIds = [...new Set(orderIds.map(o => o.order_id || o))];
      for (const orderId of uniqueOrderIds) {
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': tkn,
            'X-CSRF-Token': csrf.csrf
          },
          body: JSON.stringify({
            email: frmEmail,
            first: frmFn,
            order_id: orderId
          })
        };

        try {
          const response = await fetch(FunctionsData.getApiUrl("/api/mailer/voucherResend"), requestOptions);
          if (!response.ok) {
            throw new Error('Failed to resend voucher for order: ' + orderId);
          }
        } catch (error) {
          console.error(error);
          failures++;
        }
      }

      setResending(false);
      if (failures > 0) {
        toast.error('Some voucher emails could not be resent. Please try again later.');
      } else {
        setResendMessage("Great! We are resending your voucher email now. Please check your junk/spam folder if you don't see the email in your inbox. If you have any questions, please email snipnchip@spca.nz");
      }

    } catch (err) {
      console.error(err);
      toast.error('Error resending voucher emails. Please try again later.');
      setResending(false);
    }
  };

  const handleResendVouchersClick = () => {
    handleResendVouchers(voucherOrderIds, lostEmail, "User");
  };
const resetSelection = () => {
  setSelectedOption(null);
   props.setMicrochipOnly(false);
};
 const PageSelect = () => { 
    console.log("hitting pageselect function",props);
     console.log("selectoption in pageselect ",selectedOption);
 if (step === 0) {
  return (
    <StartPage
      key={selectedOption ?? "initial"}
      setStep={setStep}
      microchipOnly={props.microchipOnly}
      setMicrochipOnly={props.setMicrochipOnly}
      onOption={(opt) => {
        setSelectedOption(opt);
        props.setMicrochipOnly(opt === "microchip");
      }}
      initialOption={selectedOption}
      resetSelection={() => setSelectedOption(null)}  // 🛠 needed!
      onOpenLostVoucher={handleOpenLostVoucher}  // Lost Voucher Email Handle
    />
  );
}

  if (step === 1) {
    return (
      <StepperComponent
        step={step}
        setStep={setStep}
        ReactGA={props.ReactGA}
        microchipOnly={props.microchipOnly}
        setMicrochipOnly={props.setMicrochipOnly}
    resetSelection={resetSelection}
      />
    );
  }

  return null;
};


  return (
    <div className={"content"}>
      <img src={logo} style={{ width: 150, marginTop: 20 }} alt="SPCA logo" />
      {props.microchipOnly && <div style={{ color: 'red' }}>This is a microchip only voucher.</div>}
      <Container maxWidth="lg" sx={{ bgcolor: 'transparent', padding: 2 }}>
        <PageSelect />
        <ToastContainer />

        <Dialog open={lostVoucherOpen} onClose={handleCloseLostVoucher}>
          {/* Only show the dialog title if we have not set the resendMessage */}
          {!resendMessage && <DialogTitle>Lost Your Voucher Email?</DialogTitle>}
          <DialogContent>
            {/* If we have a resendMessage, show it and no email form or search results */}
            {resendMessage ? (
              <DialogContentText>
                {resendMessage}
              </DialogContentText>
            ) : (
              <>
                <DialogContentText>
                  Please enter the email address you used to get your voucher. We'll search our system and you can request a resend if found.
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Email Address"
                  type="email"
                  fullWidth
                  variant="standard"
                  value={lostEmail}
                  onChange={(e) => setLostEmail(e.target.value)}
                  disabled={resending}
                />
                {fetchingVouchers && <p>Searching for vouchers...</p>}
                {voucherCount !== null && !fetchingVouchers && (
                  voucherCount > 0 ?
                    <div>
                      <p>{voucherCount} voucher(s) found. Resend voucher email?</p>
                    </div>
                    :
                    <div>
                      <p>No vouchers found for that email address.</p>
                      <p>Please contact <a href="mailto:snipnchip@spca.nz">snipnchip@spca.nz</a>.</p>
                    </div>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions>
            {resending && (
              <div style={{ marginRight: 'auto', marginLeft: '20px' }}>
                <CircularProgress size={24} />
                <span style={{ marginLeft: '10px' }}>Sending...</span>
              </div>
            )}
            {!resendMessage && voucherCount === null && (
              <Button onClick={handleSearchVouchers} disabled={!lostEmail || resending}>Search</Button>
            )}
            {!resendMessage && voucherCount !== null && voucherCount > 0 && !resending && (
              <Button onClick={handleResendVouchersClick}>Yes, Resend</Button>
            )}
            <Button onClick={handleCloseLostVoucher} disabled={resending}>Close</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </div>
  )
}

const Steps = ({ steps, aStep }) => {
  return (
    <Stepper activeStep={aStep} alternativeLabel sx={{ padding: 0, margin: 0 }}>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))} 
     </Stepper>
  )
}
